import React from "react";
import { Flex, Text, Box } from "@chakra-ui/react";
import { CheckCircleIcon, CloseIcon } from "@chakra-ui/icons";
import { getFilterConfig, ATTENDEE_FILTERS } from "@utils/attendeeHelpers";

const AttendeeFilters = ({
  activityType,
  activeFilter,
  onFilterChange,
  activity,
}) => {
  const filterConfig = getFilterConfig(activityType, activity);

  const FilterIcon = ({ icon }) => {
    switch (icon) {
      case "check":
        return <CheckCircleIcon fontSize="md" color="green.500" />;

      case "check_yellow":
        return <CheckCircleIcon fontSize="md" color="yellow.500" />;

      case "close":
        return (
          <Box
            w={4}
            h={4}
            bg="red.500"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CloseIcon w={2} h={2} color="white" />
          </Box>
        );

      default:
        return null;
    }
  };

  const FilterButton = ({ filter, isActive, onClick }) => {
    const hasIcon = filter.icon && !filter.label;

    return (
      <Flex
        justify="center"
        align="center"
        gap={2.5}
        px={2.5}
        py={1}
        border="1px solid"
        borderColor={isActive ? "#98A2B3" : "#D0D5DD"}
        borderRadius="100px"
        bg="white"
        cursor="pointer"
        onClick={onClick}
        opacity={!isActive && !hasIcon ? 0.5 : 1}
        _hover={{ opacity: 1 }}
      >
        {filter.icon && <FilterIcon icon={filter.icon} />}
        {filter.label && (
          <Text
            fontSize="12px"
            fontWeight="500"
            color={isActive ? "#000C3B" : "#AAAEBE"}
            lineHeight="18px"
          >
            {filter.label}
          </Text>
        )}
      </Flex>
    );
  };

  return (
    <Flex align="center" gap={1.5} p={3} bg="white" alignSelf="stretch">
      {filterConfig.map((filter) => (
        <FilterButton
          key={filter.key}
          filter={filter}
          isActive={activeFilter === filter.key}
          onClick={() => onFilterChange(filter.key)}
        />
      ))}
    </Flex>
  );
};

export default AttendeeFilters;
